import CutOffText from '@/components/CutOffText';
import Image from 'next/image';
import Rate from '@/components/Rate';
import { useIsMobile } from '@/hooks/use-is-mobile';
import { cn } from '@/lib/utils';
import classes from './reviewsPage.module.css';

const ReviewItem = props => {
  const { item, onItemImageClick } = props;

  const { isMobile } = useIsMobile();

  const cutOffLength = isMobile ? 200 : 625;

  const imageLength = Math.min(item.review_image.length, 4);

  return (
    <li
      className={cn(
        'flex flex-col lg_flex-row',
        'border-b-1 border-solid border-[#DDDDDD] pb-[20px] lg_border-none lg_pb-0',
      )}
    >
      <div className='hidden w-[160px] flex-col gap-[20px] border-r-1 border-[#ddd] font-sans text-[18px] text-title lg_flex'>
        <p className='overflow-hidden text-ellipsis whitespace-nowrap pr-2'>{item.nickname}</p>
        <p>{item.created_at}</p>
      </div>
      <div className='flex-1 flex-col justify-start lg_pl-[20px]'>
        <div className='hidden items-center justify-start lg_flex'>
          <Rate
            disabled
            initialRating={item.average_rating / 20}
          />
          <div className='mx-[20px] hidden h-[22px] w-[1px] bg-[#ddd] lg_block'></div>
          <div className='flex items-center gap-[10px]'>
            {item.review_helpful.is_help_count >= item.review_helpful.is_not_help_count ? (
              <p className='flex items-center gap-[10px] font-sans leading-[1.4] text-primary'>
                <span className={classes.helpfullIcon}></span>
                Would Recommend
              </p>
            ) : (
              <p className='flex items-center gap-[10px] font-sans leading-[1.4] text-[#666]'>
                <span className={classes.notHelpfullIcon}></span>
                Would Not Recommend
              </p>
            )}
          </div>
        </div>
        <div className='font-poppins text-[16px] font-[600] leading-[1.4] text-title lg_mt-[20px] lg_text-[20px]'>
          {item.summary}
        </div>
        <div className='mt-[10px] flex items-center justify-between lg_hidden'>
          <Rate
            disabled
            initialRating={item.average_rating / 20}
          />
          <div className='flex items-center'>
            {item.review_helpful.is_help_count >= item.review_helpful.is_not_help_count ? (
              <p className='flex items-center gap-[5px] font-sans text-[16px] leading-[1.4] text-primary'>
                <span className={classes.helpfullIcon}></span>
                Would Recommend
              </p>
            ) : (
              <p className='flex items-center gap-[5px] font-sans text-[16px] leading-[1.4] text-[#666]'>
                <span className={classes.notHelpfullIcon}></span>
                Would Not Recommend
              </p>
            )}
          </div>
        </div>
        <div className='mt-[10px] flex items-center justify-between font-sans leading-[1.4] text-title lg_hidden'>
          <p>{item.nickname}</p>
          <p>{item.created_at}</p>
        </div>
        <div className='mt-[10px] font-sans text-[16px] leading-[1.4] text-title  lg_mt-[20px]'>
          <CutOffText
            text={item.text}
            length={cutOffLength}
          />
        </div>
        <div className={'lg_w-fi mt-[10px] w-full overflow-auto lg_mt-[20px]'}>
          <div
            className='flex'
            style={{
              width: imageLength * 130,
            }}
          >
            {item.review_image.slice(0, 4).map((image, index) => {
              return (
                <span
                  className={cn('mr-2.5', 'cursor-pointer')}
                  onClick={() => {
                    onItemImageClick(item.review_image, index);
                  }}
                  key={index}
                >
                  <Image
                    width={260}
                    height={280}
                    className={cn('h-[140px] w-[130px] object-cover')}
                    alt='Review Image'
                    src={image.url.replace(/\/thumb_/, '/')}
                  />
                </span>
              );
            })}
          </div>
        </div>
        {item.reply ? (
          <div className='mt-5 flex items-start gap-x-3 text-title lg_mt-10'>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='24'
              height='24'
              fill='none'
              stroke='currentColor'
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth='2'
              className='hidden lg_block'
              viewBox='0 0 24 24'
            >
              <path d='m15 10 5 5-5 5'></path>
              <path d='M4 4v7a4 4 0 0 0 4 4h12'></path>
            </svg>

            <div className='flex-1 rounded-[10px] bg-[#f4f4f4] p-[15px] lg_px-[27px] lg_py-[18px]'>
              <div className='font-poppins text-[16px] font-[600] leading-[1.4]  lg_text-[20px]'>
                Response from Kingsyard
              </div>
              <div className='mt-2.5 lg_mt-[15px]'>
                <CutOffText
                  text={item.reply}
                  length={cutOffLength}
                />
              </div>
              {item.reply_date ? (
                <div className='mt-[15px] font-sans lg_mt-5'>
                  {new Intl.DateTimeFormat('en-US', {
                    month: 'short',
                    day: 'numeric',
                    year: 'numeric',
                  }).format(new Date(item.reply_date))}
                </div>
              ) : null}
            </div>
          </div>
        ) : null}
      </div>
    </li>
  );
};

export default ReviewItem;
